// import VideoModal from '../ModalVideo/VideoModal'
import { Link } from 'react-router-dom'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'
import abImg2 from '../../images/about/about-1/2.jpg'

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section id="about" className={'' + props.hclass}>
      <div className="about-wrap container">
        <div className="about-content">
          <div className="content">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              About Ain Almansaf
            </h2>
            {/* <h3>High expectations for increased economic growth, commodity prices and Investments overall</h3> */}
            <p className="fade_bottom">
              Ain Almansaf Ltd. specializes in providing high-quality household materials designed for comfort, durability, and everyday convenience. We offer a wide range of trusted products that serve homes, businesses, and retail partners with reliable standards and competitive value. At Ain Almansaf, we focus on quality, customer satisfaction, and long-term relationships built on trust and service.
            </p>
            <div>
        {/* <div class="card-header">
            <div class="number">10</div>
            <div class="anniversary-text">Anniversary</div>
        </div> */}
        {/* <div className="card-content">
           
            <div className="years-experience fade_bottom">
                <h2>10</h2>
                <p>Years experience</p>
            </div>
        </div> */}
    </div>
            {/* <div className="about-btn ">
              <Link onClick={ClickHandler} to="/about" className="theme-btn">
              <span className="rolling-text">Learn More About Us</span>
                <RollingText text={'Learn More About Us'} />
              </Link>
            </div> */}
          </div>
        </div>
        <div>
          <div className="image">
            {/* <div className="image-1  poort-in-right">
              <img src={abImg2} alt="" />
            </div> */}
            <div className="image-2 poort-in-right">
              <img className="img-about" src={abImg2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
